export default __webpack_public_path__ + "static/media/circle-plus.cb28ef81.svg";